import { render } from "./HomeView.vue?vue&type=template&id=2be45d18&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2be45d18&scoped=true&lang=css"

import exportComponent from "C:\\FrontEnd\\JelentkezesiRendszer\\jelentkezesirendszer_frontend_user\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be45d18"]])

export default __exports__